import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SwitchListItem from '../../../../../list-items/SwitchListItem/SwitchListItem';

const VisualizerWaveDelayListItem = (props) => {
    const { visualizerDelayed, updateVisualizerSettings } = props;
    const onWaveDelayChange = (event) => updateVisualizerSettings({ delayed: event.target.checked });
    
    return (
        <SwitchListItem
            text='Wave Delay'
            checked={visualizerDelayed}
            onChange={onWaveDelayChange}
            toolTip='Delays the motion of further back wave layers. When enabled, further back layers will trail the movement of the layer in front of them.'
        />
    );
};

const mapStateToProps = (state) => {
    const { delayed: visualizerDelayed } = state.createPreview.present.videoSettings.visualizer;
    return { visualizerDelayed };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerWaveDelayListItem);